// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remote-in-person-campaign-component img.loader{position:absolute;padding:.5rem 0 0 .5rem}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/notifications/remote-in-person-campaign.vue"],"names":[],"mappings":"AAEC,gDAGC,iBAAA,CACA,uBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
